module.exports = __webpack_public_path__ + "static/media/Img_7.c311bfc7.jpg";